var View = require('views/base/view');

var ActionPlanTopicResponseView = View.extend({
  template: require('./templates/action-plan-topic-response'),
  className: 'action-plan-topic-response',
  autoRender: true
});

module.exports = ActionPlanTopicResponseView;
